var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "lease-carousel position-relative" }, [
    _vm.loadingLeases
      ? _c(
          "div",
          { staticClass: "justify-content-center text-center p-3" },
          [_c("b-spinner")],
          1
        )
      : _c("div", [
          _vm.currentLeases.length > 0
            ? _c(
                "div",
                [
                  _c("h6", [_vm._v("Choose Lease")]),
                  _c("p", [
                    _vm._v(
                      "This is the default payment that will be used to pay-off the lease you choose below."
                    ),
                  ]),
                  _c(
                    "b-carousel",
                    {
                      staticClass: "w-100",
                      attrs: {
                        value: _vm.currentIndex,
                        controls: "",
                        indicators: "",
                        background: "#fff",
                        interval: 0,
                        touch: "",
                      },
                      on: { input: _vm.onSlideChange },
                    },
                    _vm._l(_vm.currentLeases, function (lease, idx) {
                      return _c("b-carousel-slide", {
                        key: lease.id,
                        staticClass: "lease-slide",
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "img",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "lease-slide-content",
                                      class: {
                                        selected:
                                          lease.id === _vm.selectedLease?.id,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectLease(lease)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "lease-slide__info" },
                                        [
                                          _c("div", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("Contract Number")
                                                ) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " + _vm._s(lease.loan_number)
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Contract Date")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("fn-format-date", {
                                                attrs: {
                                                  format: "MM/DD/YYYY",
                                                  value: lease.application_date,
                                                  "ignore-time-zone": true,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("div", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Store")) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " + _vm._s(lease.store_name)
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "lease-slide__coapplicant",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              class: {
                                                disabled: !lease.hasCoapplicant,
                                              },
                                            },
                                            [
                                              _c("input", {
                                                attrs: {
                                                  type: "checkbox",
                                                  disabled:
                                                    !lease.hasCoapplicant ||
                                                    _vm.currentLeases.length ===
                                                      1,
                                                },
                                                domProps: {
                                                  checked:
                                                    _vm.isCoapplicant(lease),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleCoapplicant(
                                                      lease.id
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "I am the coapplicant"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "carousel-dots mt-2 d-flex justify-content-center",
                    },
                    [
                      _vm.currentLeases.length <= 5
                        ? _c(
                            "div",
                            _vm._l(_vm.currentLeases, function (lease, idx) {
                              return _c("span", {
                                key: lease.id,
                                staticClass: "dot",
                                class: { active: idx === _vm.currentIndex },
                                on: {
                                  click: function ($event) {
                                    return _vm.goToSlide(idx)
                                  },
                                },
                              })
                            }),
                            0
                          )
                        : _c("span", [
                            _vm._v(
                              _vm._s(_vm.currentIndex + 1) +
                                " of " +
                                _vm._s(_vm.currentLeases.length)
                            ),
                          ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }